import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum GenericCardSpaces {
  None = 'none',
  Nano = 'nano',
  XXXS = 'xxxs',
  XXXSNano = 'xxxs-nano',
  NanoXXXS = 'nano-xxxs',
  XXXSCompact = 'xxxs-compact',
}

export interface GenericCardHeaderSelected {
  IsEnabled: boolean;
  Title: string;
}

export interface GenericCardHeaderSummary extends GenericCardHeaderSelected {
  IsEnabled: boolean;
  Title: string;
  Description: string;
  Icon?: Icon;
  Action?: GenericCardHeaderSummaryAction;
}

export interface GenericCardHeaderSummaryAction {
  Label?: string;
  Icon?: string;
}

export interface GenericCardImage {
  IsEnabled: boolean;
  Src: string;
  SrcFallback?: string;
  DiscountLabel?: string;
}

export interface GenericCardHeader {
  Selected?: GenericCardHeaderSelected;
  Summary?: GenericCardHeaderSummary;
}

export interface GenericCardFooter {
  IsEnabled: boolean;
  IsLoading: boolean;
  Title: string;
  Icon: Icon;
  CustomAction?: GenericCardFooterCustomAction;
}

export interface GenericCardFooterCustomAction {
  Label: string;
  Icon: Icon;
}
